












































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import TableSortMixin from '@/components/mixins/TableSortMixin.vue'

// Model
import { GeofenceNotificationModel } from '@/_interfaces/GeofenceNotification'

// Interfaces
import { IDropdownList } from '@/_interfaces'

// Helpers
import { Debounce, getUniqueListBy } from '@/_utils/utils'

// Components
import NotFound from '@/components/common/NotFound.vue'
import GeofenceNotificationDetail from '@/components/notification/partials/GeofenceNotificationDetail.vue'
import FilterDropdown from '@/components/shared/FilterDropdown.vue'
import LabelButtonInput from '@/components/common/buttons/LabelButtonInput.vue'
import DropdownSearch from '@/components/common/buttons/DropdownSearch.vue'

@Component({
  components: {
    NotFound,
    GeofenceNotificationDetail,
    FilterDropdown,
    LabelButtonInput,
    DropdownSearch,
  },
})
export default class GeofenceNotification extends mixins(TableSortMixin) {
  @Prop() parent!: any

  isOpenFilter: boolean = false

  filedNameLUT: any = {
    _id: 'UUID',
    san_id: 'label.san_id',
    name: 'label.username',
  }

  childrentFilterByUsers: any = {
    selectedFilter: 'san_id',
    searchQuery: '',
    userIdsSearching: [],
  }

  childrentFilterByLocation: any = {
    selectedFilter: 'location_start',
    searchQuery: '',
  }

  dropdownList: IDropdownList[] = [
    {
      value: 'san_id',
      label: this.$t('label.san_id').toString(),
    },
    {
      value: 'name',
      label: this.$t('label.username').toString(),
    },
  ]

  get filterUsers() {
    if (!this.parent.seletedGeofence._id) {
      return []
    }

    return this.parent.seletedGeofence.geofence_users
  }

  get filterLocation() {
    if (!this.parent.seletedGeofence._id) {
      return []
    }

    return getUniqueListBy(this.filteredData, this.childrentFilterByLocation.selectedFilter)
  }

  get filteredData() {
    this.parent.numofPage = Math.ceil(this.parent.totalData / this.parent.pageFilters.perPage)
    return this.parent.notifications
  }

  @Watch('childrentFilterByLocation.searchQuery')
  @Debounce(400)
  onSearchLocation() {
    this.parent.extendSearch.location = this.childrentFilterByLocation.searchQuery
    this.parent.getNotificationData()
  }

  @Watch('childrentFilterByUsers.searchQuery')
  @Debounce(400)
  onSearchText() {
    this.searchUserToSever()
  }

  searchUserToSever() {
    const userIds = this.filterUsers
      .filter(item => {
        const fieldSearch = this.childrentFilterByUsers.selectedFilter
        const fieldFilter = fieldSearch === 'name' ? 'u_name' : fieldSearch

        return item[fieldFilter]
          .toString()
          .toLowerCase()
          .includes(this.childrentFilterByUsers.searchQuery.toLowerCase())
      })
      .map(item => item._id)

    this.parent.extendSearch.user_ids = this.childrentFilterByUsers.searchQuery ? userIds.join(',') : []
    this.parent.getNotificationData()
  }

  onPageChange(page: number) {
    this.parent.pageFilters.currentPage = page
    this.parent.getNotificationData()
  }

  convertFieldName(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUT[value]) as string
  }

  onDetailOpen(row: GeofenceNotificationModel) {
    if (!row || [...row.operators_read].includes(this.parent.currentUser._id)) {
      return
    }

    const data = {
      _id: row._id,
      reader_id: this.parent.currentUser._id,
      type: this.parent.typeComponent,
    }

    this.$store.dispatch('notifications/readNotificaiton', data)
  }

  checkBoxStatus(row: GeofenceNotificationModel): boolean {
    if (!this.parent.currentUser) {
      return false
    }

    return row.operators_read.includes(this.parent.currentUser._id)
  }

  created() {
    this.tableRef = 'geofenceNotification'
  }
}
